import React, {useEffect, useState, FC} from 'react'

import PencilIcon from '@mui/icons-material/Edit'
import {isTouchDevice} from '../../lib/util'
import {Fade, Paper, Typography, IconButton} from "@mui/material";
import {useAuth} from "../../hooks/use-auth";
import {useSelector} from "../../store";

interface ProfileCardProps {
    title: string;
    editing: boolean;
    onEditingChanged: (newEditValue: boolean) => void;
    children?: React.ReactNode
}

export const ProfileCard: FC<ProfileCardProps> = ({children, title, editing, onEditingChanged}) => {

    const [showPen, setShowPen] = useState(false)

    const {currentProfile: {uid}} = useSelector((state) => state.userSession);

    const auth = useAuth()

    const isAdmin = auth.isAdmin;

    const isAllowedToEdit = auth.user?.uid === uid || isAdmin;


    useEffect(() => {

        if (isAllowedToEdit && !showPen && isTouchDevice()) {
            setShowPen(true)
        }

    }, [isAllowedToEdit])

    //
    // const children = React.Children.map(childrenProp, child => {
    //     if (!React.isValidElement(child)) {
    //         return null
    //     }
    //
    //     return child
    // })

    const toggleEditing = () => {
        if (onEditingChanged) {
            onEditingChanged(!editing)
        }
    }

    const handleMouseEnter = (event: any) => {
        shouldShowPen()
    }

    const handleMouseLeave = (event: any) => {
        hidePenUnlessTouch()
    }

    const handleClick = (event: any) => {

        if (isAllowedToEdit && !editing) {
            shouldShowPen()
            toggleEditing()
        }
    }

    const handlePenClick = (event: any) => {
        toggleEditing()
    }

    // componentDidUpdate (prevProps, prevState, snapshot) {
    //   if (!this.props.editing && prevProps.editing !== this.props.editing) {
    //     this.hidePenUnlessTouch()
    //   }
    //
    //   // if (this.props.canEdit && !isTouchDevice() && prevProps.canEdit !== this.props.canEdit) {
    //   //   this.showPen()
    //   // }
    // }

    // static getDerivedStateFromProps (props, state) {
    //   if (!props.canEdit) {
    //     return {showPen: false}
    //   } else {
    //     if (isTouchDevice()){
    //       return {showPen: true}
    //     } else {
    //       return null
    //     }
    //   }
    // }

    const hidePenUnlessTouch = () => {
        if (!isTouchDevice()) {
            setShowPen(false)
        }
    }

    const shouldShowPen = () => {
        if (isAllowedToEdit) {
            setShowPen(true)
        }

    }

    return <Paper
        elevation={8}
        sx={{
            position: "relative",
            py: 3,
            px: {
                xs: 1,
                md: 3
            },
            mt: 3,
            // cursor: isAllowedToEdit && !editing ? "pointer" : "inherit",
            background: editing ? "#eeeeee" : ""
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        // onClick={handleClick}
    >

        <Fade mountOnEnter unmountOnExit in={showPen || editing} style={{position: 'absolute', right: 8, top: 8}}>
            <IconButton onClick={handlePenClick}>
                <PencilIcon color={editing ? 'primary' : 'inherit'}/>
            </IconButton>
        </Fade>

        <Typography variant={"h4"} style={{color: '#5F5F5F'}}>{title}</Typography>

        {children}
    </Paper>
}
